import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const fetchCatalogs = createAsyncThunk(
   'catalogs/fetchCatalogs',
   async (pageSize, thunkAPI) => {
      const current = thunkAPI.getState().catalogs.entities.length
      try {
         const response = await API.get(`/catalogs`, {params: {size: pageSize, current: current}})
         return response.data
      } catch (err) {
         thunkAPI.dispatch(setError({ action: 'fetchCatalogs', code: err.response.status, message: err.message }))
         return thunkAPI.rejectWithValue()
      }
   },
   {
      condition: (pageSize, { getState }) => {
         const { catalogs } = getState()
         if (catalogs.loading || pageSize <= catalogs.entities.length) return false
      }
   }
)

const initialState = {
   entities: [],
   total: null,
   loading: false
}

const catalogsSlice = createSlice({
   name: 'catalogs',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchCatalogs.pending, state => {
         state.loading = true
         state.error = null
      })
      builder.addCase(fetchCatalogs.fulfilled, (state, action) => {
         action.payload.catalogs.forEach(item => state.entities.push(item))
         state.loading = false
         if (!state.total) state.total = action.payload.total
      })
      builder.addCase(fetchCatalogs.rejected, state => {
         state.loading = false
      })
   }
})

export const catalogs = catalogsSlice.reducer
